import { render, staticRenderFns } from "./CrudNav.vue?vue&type=template&id=9b788070&"
import script from "./CrudNav.vue?vue&type=script&lang=js&"
export * from "./CrudNav.vue?vue&type=script&lang=js&"
import style0 from "./CrudNav.vue?vue&type=style&index=0&id=9b788070&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports